import { combineReducers } from "redux";
import salesRepDataReducer from "./salesRepDataReducer";
var reducer = combineReducers({
    salesRepData: salesRepDataReducer,
});
export default reducer;
